// extracted by mini-css-extract-plugin
export default {"button":"playTextButton_button__muYzf","audio":"playTextButton_audio__LSnWd"};